import { babyface } from '../CDNUrl';

const HOME_BANNER_URI = `${babyface}/home/home_banner`;

export const HOME_BANNER_FALL = {
  src: `${HOME_BANNER_URI}_fall.jpg`,
  alt: `혜택 이벤트 홈배너`,
};
